module.exports = __webpack_public_path__ + "img/Apoptosis-GBM_SPATA.6e8f3f15.png";